var map = {
	"./ceo-introduction.png": "WnL2",
	"./ceo-introduction@2x.png": "hxg1",
	"./financial-performance.png": "hXh/",
	"./financial-performance@2x.png": "5ddh",
	"./focus-areas.png": "O1cT",
	"./focus-areas@2x.png": "Qs3r",
	"./future-energy.png": "ZJJV",
	"./future-energy@2x.png": "wvxy",
	"./governance.png": "vVOQ",
	"./governance@2x.png": "DWZG",
	"./operations.png": "v7Rt",
	"./operations@2x.png": "mpNg",
	"./people.png": "fMAz",
	"./people@2x.png": "gf56",
	"./uk-power-network-services.png": "vCqu",
	"./uk-power-network-services@2x.png": "uXus",
	"./ukpn-annual-review-2018.png": "aNig",
	"./ukpn-annual-review-2018@2x.png": "RaE7",
	"./vision-values.png": "4Ws7",
	"./vision-values@2x.png": "Tr48"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Mwav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers ^\.\/.*\.png$
// module id = Mwav
// module chunks = 10